import { $api } from "@/shared/api";

import { LOGIN_PAGE, leavePage } from "../lib/leavePage";

// Удаление аккаунта: `DELETE /api/me` с `{confirm: true}`, затем полный переход на вход —
// как после выхода, бэкенд уже завершил сессию. 401 значит, что сессии уже нет
// (аккаунт удалён в другой вкладке), — тоже уходим на вход.
export const useDeleteAccount = () =>
  $api.useMutation("delete", "/api/me", {
    onSuccess: () => {
      leavePage(LOGIN_PAGE);
    },
    onError: (error) => {
      if (error.status === 401) {
        leavePage(LOGIN_PAGE);
      }
    },
  });
